"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllUrlParams = void 0;
const getAllUrlParams = (url = window.location.search) => {
    let queryString = url.split('?')[1];
    const obj = {};
    if (queryString) {
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const params = queryString.split('&');
        for (let index = 0; index < params.length; index++) {
            const param = params[index].split('=');
            const paramName = param[0];
            const paramValue = typeof param[1] === 'undefined' ? true : param[1];
            if (paramName.match(/\[(\d+)?\]$/)) {
                const key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key])
                    obj[key] = [];
                if (paramName && paramName.match(/\[\d+\]$/)) {
                    // @ts-ignore
                    const indexObj = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][indexObj] = paramValue;
                }
                else {
                    obj[key].push(paramValue);
                }
            }
            else {
                if (!obj[paramName]) {
                    obj[paramName] = paramValue;
                }
                else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                }
                else {
                    obj[paramName].push(paramValue);
                }
            }
        }
    }
    return obj;
};
exports.getAllUrlParams = getAllUrlParams;
